var render = function () {
  var _vm$getSiteConfigData, _vm$getSiteConfigData2, _vm$getSiteConfigData3, _vm$getSiteConfigData4, _vm$getSiteConfigData5, _vm$getSiteConfigData6, _vm$getSiteConfigData7, _vm$getSiteConfigData8, _vm$getSiteConfigData9, _vm$getSiteConfigData0, _vm$getSiteConfigData1, _vm$getSiteConfigData10, _vm$getSiteConfigData11, _vm$getSiteConfigData12, _vm$getSiteConfigData13, _vm$getSiteConfigData14, _vm$getSiteConfigData15, _vm$getSiteConfigData16, _vm$getSiteConfigData17, _vm$getSiteConfigData18, _vm$getSiteConfigData19, _vm$getSiteConfigData20, _vm$getSiteConfigData21, _vm$getSiteConfigData22, _vm$getSiteConfigData23, _vm$getSiteConfigData24, _vm$getSiteConfigData25;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "foot_top"
  }, [_c('div', {
    staticClass: "wrap fixed"
  }, [_c('div', {
    staticClass: "foot_ll"
  }, [_c('ul', {
    staticClass: "fixed"
  }, _vm._l((_vm$getSiteConfigData = _vm.getSiteConfigData) === null || _vm$getSiteConfigData === void 0 ? void 0 : _vm$getSiteConfigData.footerLinkList, function (item, index) {
    return _c('li', {
      key: index
    }, [_c('h3', {
      staticClass: "fnt_18 bold"
    }, [_vm._v(_vm._s(item.linkName))]), _vm._l(item.children, function (itemOne, inx) {
      return _c('p', {
        key: inx
      }, [_c('a', {
        attrs: {
          "href": itemOne.linkUrl
        }
      }, [_vm._v(_vm._s(itemOne.linkName))])]);
    })], 2);
  }), 0)]), _c('div', {
    staticClass: "foot_rr fixed"
  }, [_vm.isWxEnv == false ? _c('dl', {
    staticClass: "fixed select-box fnt_14"
  }, [_vm._m(0), _c('dd', _vm._l((_vm$getSiteConfigData2 = _vm.getSiteConfigData) === null || _vm$getSiteConfigData2 === void 0 ? void 0 : _vm$getSiteConfigData2.linkList, function (item, index) {
    return _c('a', {
      key: index,
      attrs: {
        "target": "_blank",
        "href": item.linkUrl
      }
    }, [_vm._v(_vm._s(item.linkName))]);
  }), 0)]) : _vm._e(), _c('div', {
    staticClass: "share fnt_30"
  }, [_vm._m(1), _c('a', {
    attrs: {
      "href": "javascriot:void(0)"
    }
  }, [_c('i', {
    staticClass: "icon-weixin"
  }), _c('div', {
    staticClass: "code"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": (_vm$getSiteConfigData3 = _vm.getSiteConfigData) === null || _vm$getSiteConfigData3 === void 0 ? void 0 : (_vm$getSiteConfigData4 = _vm$getSiteConfigData3.commonInfo) === null || _vm$getSiteConfigData4 === void 0 ? void 0 : _vm$getSiteConfigData4.photo3
    }
  }), _c('p', {
    staticClass: "fnt_14"
  }, [_vm._v(_vm._s((_vm$getSiteConfigData5 = _vm.getSiteConfigData) === null || _vm$getSiteConfigData5 === void 0 ? void 0 : (_vm$getSiteConfigData6 = _vm$getSiteConfigData5.commonInfo) === null || _vm$getSiteConfigData6 === void 0 ? void 0 : _vm$getSiteConfigData6.singleLine7))])])])])])])]), _c('div', {
    staticClass: "foot_bot fnt_14"
  }, [_c('div', {
    staticClass: "wrap fixed"
  }, [_c('p', {
    staticClass: "fb_ll"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "/other/sitemap.html"
    }
  }, [_vm._v("网站地图")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "/other/law.html"
    }
  }, [_vm._v("法律声明")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "/contact/contact.html"
    }
  }, [_vm._v("联系我们")]), (_vm$getSiteConfigData7 = _vm.getSiteConfigData) !== null && _vm$getSiteConfigData7 !== void 0 && (_vm$getSiteConfigData8 = _vm$getSiteConfigData7.commonInfo) !== null && _vm$getSiteConfigData8 !== void 0 && _vm$getSiteConfigData8.singleLine1 ? _c('span', [_vm._v("电话："), _c('a', {
    staticClass: "tel_link",
    attrs: {
      "href": 'tel:' + ((_vm$getSiteConfigData9 = _vm.getSiteConfigData) === null || _vm$getSiteConfigData9 === void 0 ? void 0 : (_vm$getSiteConfigData0 = _vm$getSiteConfigData9.commonInfo) === null || _vm$getSiteConfigData0 === void 0 ? void 0 : _vm$getSiteConfigData0.singleLine1)
    }
  }, [_vm._v(_vm._s((_vm$getSiteConfigData1 = _vm.getSiteConfigData) === null || _vm$getSiteConfigData1 === void 0 ? void 0 : (_vm$getSiteConfigData10 = _vm$getSiteConfigData1.commonInfo) === null || _vm$getSiteConfigData10 === void 0 ? void 0 : _vm$getSiteConfigData10.singleLine1))])]) : _vm._e(), (_vm$getSiteConfigData11 = _vm.getSiteConfigData) !== null && _vm$getSiteConfigData11 !== void 0 && (_vm$getSiteConfigData12 = _vm$getSiteConfigData11.commonInfo) !== null && _vm$getSiteConfigData12 !== void 0 && _vm$getSiteConfigData12.singleLine2 ? _c('span', [_vm._v("传真：" + _vm._s((_vm$getSiteConfigData13 = _vm.getSiteConfigData) === null || _vm$getSiteConfigData13 === void 0 ? void 0 : (_vm$getSiteConfigData14 = _vm$getSiteConfigData13.commonInfo) === null || _vm$getSiteConfigData14 === void 0 ? void 0 : _vm$getSiteConfigData14.singleLine2))]) : _vm._e(), (_vm$getSiteConfigData15 = _vm.getSiteConfigData) !== null && _vm$getSiteConfigData15 !== void 0 && (_vm$getSiteConfigData16 = _vm$getSiteConfigData15.commonInfo) !== null && _vm$getSiteConfigData16 !== void 0 && _vm$getSiteConfigData16.singleLine3 ? _c('span', [_vm._v("地址：" + _vm._s((_vm$getSiteConfigData17 = _vm.getSiteConfigData) === null || _vm$getSiteConfigData17 === void 0 ? void 0 : (_vm$getSiteConfigData18 = _vm$getSiteConfigData17.commonInfo) === null || _vm$getSiteConfigData18 === void 0 ? void 0 : _vm$getSiteConfigData18.singleLine3))]) : _vm._e()]), _c('p', {
    staticClass: "fb_rr"
  }, [_c('span', [_vm._v(_vm._s((_vm$getSiteConfigData19 = _vm.getSiteConfigData) === null || _vm$getSiteConfigData19 === void 0 ? void 0 : (_vm$getSiteConfigData20 = _vm$getSiteConfigData19.commonInfo) === null || _vm$getSiteConfigData20 === void 0 ? void 0 : _vm$getSiteConfigData20.singleLine4))]), _c('em', [_vm._v(_vm._s((_vm$getSiteConfigData21 = _vm.getSiteConfigData) === null || _vm$getSiteConfigData21 === void 0 ? void 0 : (_vm$getSiteConfigData22 = _vm$getSiteConfigData21.commonInfo) === null || _vm$getSiteConfigData22 === void 0 ? void 0 : _vm$getSiteConfigData22.singleLine5))]), _c('a', {
    attrs: {
      "href": _vm.isWxEnv ? 'javascript:void(0)' : 'https://beian.miit.gov.cn/',
      "target": _vm.isWxEnv ? '_self' : '_blank'
    }
  }, [_vm._v(_vm._s((_vm$getSiteConfigData23 = _vm.getSiteConfigData) === null || _vm$getSiteConfigData23 === void 0 ? void 0 : (_vm$getSiteConfigData24 = _vm$getSiteConfigData23.commonInfo) === null || _vm$getSiteConfigData24 === void 0 ? void 0 : _vm$getSiteConfigData24.singleLine6))])])]), _c('div', {
    staticClass: "wrap fixed"
  }, [_c('p', {
    staticClass: "fb_ll"
  }, _vm._l((_vm$getSiteConfigData25 = _vm.getSiteConfigData) === null || _vm$getSiteConfigData25 === void 0 ? void 0 : _vm$getSiteConfigData25.businessCertificateList, function (item, index) {
    return _c('a', {
      key: index,
      staticClass: "link",
      attrs: {
        "href": _vm.getLinkHref(item),
        "target": _vm.getLinkTarget(item)
      }
    }, [_vm._v(_vm._s(item.linkName))]);
  }), 0)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dt', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("友情链接")]), _c('i', {
    staticClass: "icon-xiajiantou"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "share_wb",
    attrs: {
      "href": "javascriot:void(0)"
    }
  }, [_c('i', {
    staticClass: "icon-weibo"
  })]);
}]

export { render, staticRenderFns }